import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { OriginStatus } from "@/domain/entities/Origin"
import { IChangeOriginStatusProtocol } from "../../protocols/origin/IChangeOriginStatusProtocol"
import { ChangeOriginStatusUseCase } from "./changeOriginStatus"

let sut: IChangeOriginStatusProtocol
let repository: InMemoryOriginsRepository

describe('Delete Origin By Name', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new ChangeOriginStatusUseCase(repository)
  })
  it('Should be able to set a origin status as disabled', async () => {
    const originOnDatabase = makeOrigin({
      name: 'Test Origin'
   })
   await repository.create(originOnDatabase)

   await sut.execute({
    originId: originOnDatabase.id
   })

    expect(repository.items[0].updatedAt).toBeTruthy()
    expect(repository.items[0].updatedAt).toEqual(expect.any(Date))
    expect(repository.items[0].status).toEqual(OriginStatus.DISABLED)
  })

  it('Should be able to set a origin status as active', async () => {
    const originOnDatabase = makeOrigin({
      name: 'Test Origin',
      status: OriginStatus.DISABLED
   })
   await repository.create(originOnDatabase)

   await sut.execute({
    originId: originOnDatabase.id
   })

    expect(repository.items[0].updatedAt).toBeTruthy()
    expect(repository.items[0].updatedAt).toEqual(expect.any(Date))
    expect(repository.items[0].status).toEqual(OriginStatus.ACTIVE)
  })
})